export const useHelpers = () => {

    const convertToFloat = (formattedNumber) => {
        if (formattedNumber === null || formattedNumber === undefined || formattedNumber === '') return 0
        if (typeof formattedNumber === 'number') return formattedNumber
        const cleanedValue = String(formattedNumber).replace(/,/g, '')
        const floatValue = parseFloat(cleanedValue)
        return isNaN(floatValue) ? 0 : floatValue
    }

    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const extractIdVehicle = (input) => {
        const pattern = /^VH/; // Define el patrón que debe coincidir
    
        if (!pattern.test(input)) {
            return {
                statusCode: false,
                statusMessage: "El texto no coincide con el patrón requerido 'VHXXX'.",
                idcredito: null
            };
        }
    
        const numberString = input.replace(pattern, ''); // Elimina el patrón de la cadena
    
        if (numberString === '') {
            return {
                statusCode: false,
                statusMessage: "Numero de identificar incorrecto",
                idcredito: null
            };
        }
    
        const number = parseInt(numberString, 10); // Convierte el resultado en un número entero
    
        if (isNaN(number)) {
            return {
                statusCode: false,
                statusMessage: "Numero de identificar incorrecto.",
                idcredito: null
            };
        }
    
        return {
            statusCode: true,
            statusMessage: "Conversión exitosa.",
            idcredito: number
        };
    };

    function compareDates(date1, date2) {
        // Convertimos las fechas en objetos Date
        const d1 = new Date(date1);
        const d2 = new Date(date2);
      
        // Comparamos el año y el mes
        const sameMonthAndYear = d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
      
        return sameMonthAndYear;
      }
    
    const calculateLateInterest = (payment, previousOutstandingBalance, dias_atraso, dias_atraso_ultimo_pago) => {
        const paymentFloat = parseFloat(payment);
        const previousOutstandingBalanceFloat = parseFloat(previousOutstandingBalance)
        
        if(previousOutstandingBalanceFloat>0) {
          
            // const mora = calculateMora(payment, previousOutstandingBalance, dias_atraso, dias_atraso_ultimo_pago)
            // const saldo_total = previousOutstandingBalanceFloat + mora 
            return (paymentFloat + previousOutstandingBalanceFloat) * 0.10;
        } 
        return (paymentFloat) * 0.10;
    };  

    const calculateMora = (cuota_pagar, saldo_cuota_anterior, dias_atraso, dias_atraso_ultimo_pago ) =>{
        let dias_atraso_temp
        (saldo_cuota_anterior>0)&&(dias_atraso>0) ? dias_atraso_temp = dias_atraso_ultimo_pago : dias_atraso_temp = dias_atraso

        const interes_mora = calculateLateInterest(cuota_pagar, saldo_cuota_anterior)
        const pago_dias_atraso = (parseInt(dias_atraso_temp)*10)

        return (interes_mora+pago_dias_atraso)
    }

    return Object.freeze({
        convertToFloat,
        getCurrentDate,
        extractIdVehicle,
        compareDates,
        calculateLateInterest,
        calculateMora,
    })
}